import axios from 'axios';
import { headerConfig } from './utils';
import { FETCH_DASHBOARD_CATEGORIES, FETCH_DASHBOARD_PRODUCTS, FETCH_DASHBOARD_REPORTS, REQUEST_RESULT } from './types';
import { REPORTS_URL } from './report-actions';

export const fetchDashboardSalesLastMonth = (allMachineIds, selectedMachineIds, setIsLoading, setFetchingStateArray) => {
  const machineIds = selectedMachineIds[0] === null ? allMachineIds : selectedMachineIds;
  const URL = `${REPORTS_URL}/get-dashboard/SalesLastMonth`;
  setIsLoading(true);
  setFetchingStateArray(prevState => [...prevState, 'SalesLastMonth']);
  return dispatch => axios.post(`${URL}`,
    { ItemIds: machineIds },
    {
      ...dispatch(headerConfig()),
    })
    .then(response => {
      return dispatch({
        type: FETCH_DASHBOARD_REPORTS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: error.response.status === 400 ? error.response.data : 'Server error' },
      });
    })
    .finally(() => {
      setIsLoading(false);
      setFetchingStateArray(prevState => prevState.slice(0, -1));
    });
};

export const fetchDashboardTopCategories = (allMachineIds, selectedMachineIds, setIsLoading, setFetchingStateArray) => {
  const machineIds = selectedMachineIds[0] === null ? allMachineIds : selectedMachineIds;
  const URL = `${REPORTS_URL}/get-dashboard/TopSalesCategory`;
  setIsLoading(true);
  setFetchingStateArray(prevState => [...prevState, 'TopSalesCategory']);
  return dispatch => axios.post(`${URL}`,
    { ItemIds: machineIds },
    {
      ...dispatch(headerConfig()),
    })
    .then(response => {
      return dispatch({
        type: FETCH_DASHBOARD_CATEGORIES,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: error.response.status === 400 ? error.response.data : 'Server error' },
      });
    })
    .finally(() => {
      setIsLoading(false);
      setFetchingStateArray(prevState => prevState.slice(0, -1));
    });
};

export const fetchDashboardTopProducts = (allMachineIds, selectedMachineIds, setIsLoading, setFetchingStateArray) => {
  const machineIds = selectedMachineIds[0] === null ? allMachineIds : selectedMachineIds;
  const URL = `${REPORTS_URL}/get-dashboard/TopSalesProduct`;
  setIsLoading(true);
  setFetchingStateArray(prevState => [...prevState, 'TopSalesProduct']);
  return dispatch => axios.post(`${URL}`,
    { ItemIds: machineIds },
    {
      ...dispatch(headerConfig()),
    })
    .then(response => {
      return dispatch({
        type: FETCH_DASHBOARD_PRODUCTS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: error.response.status === 400 ? error.response.data : 'Server error' },
      });
    })
    .finally(() => {
      setIsLoading(false);
      setFetchingStateArray(prevState => prevState.slice(0, -1));
    });
};

export function clearSalesLastMonth() {
  return dispatch => {
    dispatch({
      type: FETCH_DASHBOARD_REPORTS,
      payload: undefined,
    });
  };
}

export function clearTopProducts() {
  return dispatch => {
    dispatch({
      type: FETCH_DASHBOARD_PRODUCTS,
      payload: undefined,
    });
  };
}

export function clearTopCategories() {
  return dispatch => {
    dispatch({
      type: FETCH_DASHBOARD_CATEGORIES,
      payload: undefined,
    });
  };
}